// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zFVUO","left":"styles_left__2PNqH","desktopActions":"styles_desktopActions__2fnd7","title":"styles_title__3d5wQ"};